// extracted by mini-css-extract-plugin
module.exports = {"Sort":"Sort_Sort__3Zifr","Sort__Label":"Sort_Sort__Label__2EThH","Sort__Icon":"Sort_Sort__Icon__QdlO7"};